export default "https://cdn.questicon.mathletics.com/assets/images/concept-refresh-7676aa865677d27cf3398fcf2274debf.svg";